export function serializeForm(form: HTMLFormElement): Array<[string, string]> {
  const formData = new FormData(form as HTMLFormElement) as unknown as Array<
    [string, string]
  >;
  return Array.from(formData).map(([key, value]) => [key, value]);
}
